export default "__VITE_ASSET__IcoKn4zz__"